import { Directive, ElementRef, HostListener, OnInit, AfterViewInit, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Dictionary, IDictionary } from '../classes/dictionary';
import { ValidationService } from '../classes/validaton-service';
import * as _ from 'underscore';

interface InputError {
    type: string;
    message: string;
    severity: number;
}

@Directive({
    selector: '[validator]'
})

export class Validator implements AfterViewInit, OnChanges {


    private element: HTMLInputElement;
    private matField: JQuery;
    private validators: IDictionary = new Dictionary([]);
    private errorMessages: InputError[];
    private customErrorMessage: string;

    @Input() ngModel: string;
    @Output() ngModelChange = new EventEmitter();

    constructor(el: ElementRef) {
        this.customErrorMessage = null;
        this.errorMessages = [];
        this.element = el.nativeElement;
        this.customErrorMessage = this.element.getAttribute('valmsg');
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.checkAttributes(this.element)
        this.matField = $(this.element).closest('mat-form-field');
            this.ngModelChange.emit(this.ngModel);
            if(this.ngModel) { this.validateAll() }
        },1000)
    }


    ngOnChanges(changes: SimpleChanges) {
        if (changes.ngModel.currentValue && changes.ngModel.currentValue != changes.ngModel.previousValue) {
            this.validateAll();
        }
        else if (!changes.ngModel.currentValue) {
            if (this.validators.containsKey('required')) { this.valRequired() }
        }
    }

    validateAll() {
        if (this.validators.containsKey('email')) { this.valEmail() }
        if (this.validators.containsKey('pattern')) { this.valPattern() }
        if (this.validators.containsKey('required')) { this.valRequired() }
        if (this.validators.containsKey('digits')) { this.digitsOnly() }
        if (this.validators.containsKey('maxvalue')) { this.valMaxValue() }
        if (this.validators.containsKey('equalsvalue')) { this.valEqualsValue() }
        if (this.validators.containsKey('landline')) { this.valLandline() }
        if (this.validators.containsKey('mobile')) { this.valMobile() }
    }

    @HostListener('blur') onblur() {
        if (this.validators.containsKey('required') && !this.validators.containsKey('select-required')) { this.valRequired() }
    }

    setClass() {
        let values: any[] = [];
        let valid: boolean = false;
        this.validators.keys().forEach((key) => { values.push(this.validators[key]) });
        if (values.every(val => val)) {
            this.element.classList.remove('hasError');
            this.matField.removeClass('mat-form-field-invalid')
            this.element.classList.remove('ng-invalid');
            this.element.classList.add('ng-valid');
            valid = true;
        }
        else {
            this.element.classList.remove('ng-valid');
            this.element.classList.add('hasError');
            this.element.classList.add('ng-invalid');
            this.matField.addClass('mat-form-field-invalid')
            valid = false;
        };
        this.setOrRemoveErrorDiv(valid);
    }

    private checkAttributes(element: HTMLInputElement) {
        if (element.hasAttribute('required')) { this.addVal("required", ValidationService.GlobalValidation.getValue(this.element.id)) }
        if (element.hasAttribute('email')) { this.addVal("email", element.hasAttribute('required') ? ValidationService.GlobalValidation.getValue(this.element.id) : true) }
        if (element.hasAttribute('pattern')) { this.addVal("pattern", element.hasAttribute('required') ? ValidationService.GlobalValidation.getValue(this.element.id) : true) }
        if (element.hasAttribute('digits')) { this.addVal("digits", element.hasAttribute('required') ? ValidationService.GlobalValidation.getValue(this.element.id) : true) }
        if (element.hasAttribute('maxvalue')) { this.addVal("maxvalue", element.hasAttribute('required') ? ValidationService.GlobalValidation.getValue(this.element.id) : true) }
        if (element.hasAttribute('equalsvalue')) { this.addVal("equalsvalue", element.hasAttribute('required') ? ValidationService.GlobalValidation.getValue(this.element.id) : true) }
        if (element.hasAttribute('landline')) { this.addVal("landline", element.hasAttribute('required') ? ValidationService.GlobalValidation.getValue(this.element.id) : true) }
        if (element.hasAttribute('mobile')) { this.addVal("mobile", element.hasAttribute('required') ? ValidationService.GlobalValidation.getValue(this.element.id) : true) }

    }

    private addVal(valName: string, validity: boolean) {
        this.validators.add(valName, validity);
        ValidationService.GlobalValidation.add(this.element.id, validity)

    }

    private digitsOnly() {
        let digitsPattern = new RegExp('^\\d+$');
        let msgType = "digits";
        if (this.ngModel.toString() && this.ngModel.toString().match(digitsPattern) || !this.ngModel) {
            let msgIndex = this.errorMessages.indexOf(this.errorMessages.find(msg => msg.type == msgType));
            this.errorMessages.splice(msgIndex)
            this.validators[msgType] = true;
        }
        else {
            if (!this.errorMessages.find(msg => msg.type == msgType)) {
                this.errorMessages.push({ type: msgType, message: this.customErrorMessage ? this.customErrorMessage : "Επιτρέπονται μόνο ψηφία", severity: 2 })
                this.validators[msgType] = false;
            }
        }
        this.setClass();
    }

    private valRequired() {
        let msgType = "required";
        if (this.ngModel) {
            let msg = this.errorMessages.find(msg => msg.type == msgType);
            if (msg) { this.errorMessages.splice(this.errorMessages.indexOf(msg)) };
            this.validators['required'] = true;
        }
        else {
            if (!this.errorMessages.find(msg => msg.type == msgType)) {
                this.errorMessages.push({ type: msgType, message: "Το πεδίο είναι υποχρεωτικό", severity: 1 })
            };
            this.validators[msgType] = false;
        }
        this.setClass();
    }

    private valEmail() {
        let mailPattern = new RegExp(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/);
        let msgType = "email";
        if (this.ngModel && this.ngModel.match(mailPattern) || !this.ngModel) {
            let msgIndex = this.errorMessages.indexOf(this.errorMessages.find(msg => msg.type == msgType));
            this.errorMessages.splice(msgIndex)
            this.validators[msgType] = true;
        }
        else {
            if (!this.errorMessages.find(msg => msg.type == msgType)) {
                this.errorMessages.push({ type: msgType, message: "Μη έγκυρη διεύθυνση email", severity: 2 })
            }
            this.validators[msgType] = false;
        }
        this.setClass();
    }

    private valLandline() {
        let pattern = new RegExp(/^2+[0-9]{9}$/);
        let msgType = "landline";

        if (this.ngModel && this.ngModel.match(pattern) || !this.ngModel) {
            let msgIndex = this.errorMessages.indexOf(this.errorMessages.find(msg => msg.type == msgType));
            this.errorMessages.splice(msgIndex)
            this.validators[msgType] = true;
        }
        else {
            if (!this.errorMessages.find(msg => msg.type == msgType)) {
                this.errorMessages.push({ type: msgType, message: "Μη έγκυρος αριθμός", severity: 2 })
            }
            this.validators[msgType] = false;
        }
        this.setClass();
    }

    private valMobile() {
        let pattern = new RegExp(/^69+[0-9]{8}$/);
        let msgType = "mobile";

        if (this.ngModel && this.ngModel.match(pattern) || !this.ngModel) {
            let msgIndex = this.errorMessages.indexOf(this.errorMessages.find(msg => msg.type == msgType));
            this.errorMessages.splice(msgIndex)
            this.validators[msgType] = true;
        }
        else {
            if (!this.errorMessages.find(msg => msg.type == msgType)) {
                this.errorMessages.push({ type: msgType, message: "Μη έγκυρος αριθμός", severity: 2 })
            }
            this.validators[msgType] = false;
        }
        this.setClass();
    }

    private valPattern() {
        let pattern = new RegExp(this.element.getAttribute('pattern'));
        let msgType = "pattern";
        if (this.ngModel && this.ngModel.toString().match(pattern) || !this.ngModel) {
            let msgIndex = this.errorMessages.indexOf(this.errorMessages.find(msg => msg.type == msgType));
            this.errorMessages.splice(msgIndex)
            this.validators[msgType] = true;
        }
        else {
            if (!this.errorMessages.find(msg => msg.type == msgType)) {
                this.errorMessages.push({ type: msgType, message: this.customErrorMessage ? this.customErrorMessage : "Μη έγκυρη καταχώριση", severity: 2 })
                this.validators[msgType] = false;
            }
        }
        this.setClass();
    }

    private valMaxValue() {
        let maxValue = this.element.getAttribute('maxvalue');
        let msgType = "maxvalue";
        if (this.ngModel && (Number(this.ngModel) <= Number(maxValue)) || !this.ngModel) {
            let msgIndex = this.errorMessages.indexOf(this.errorMessages.find(msg => msg.type == msgType));
            this.errorMessages.splice(msgIndex)
            this.validators[msgType] = true;
        }
        else {
            if (!this.errorMessages.find(msg => msg.type == msgType)) {
                this.errorMessages.push({ type: msgType, message: this.customErrorMessage ? this.customErrorMessage : "Η τιμή δεν μπορεί να είναι μεγαλύτερη από " + maxValue, severity: 2 })
                this.validators[msgType] = false;
            }
        }
        this.setClass();
    }

    private valEqualsValue() {
        let equalsvalue = this.element.getAttribute('equalsvalue');
        let msgType = "equalsvalue";
        if (this.ngModel && (Number(this.ngModel) === Number(equalsvalue)) || !this.ngModel) {
            let msgIndex = this.errorMessages.indexOf(this.errorMessages.find(msg => msg.type == msgType));
            this.errorMessages.splice(msgIndex)
            this.validators[msgType] = true;
        }
        else {
            if (!this.errorMessages.find(msg => msg.type == msgType)) {
                this.errorMessages.push({ type: msgType, message: this.customErrorMessage ? this.customErrorMessage : "Η τιμή πρέπει να είναι ίση με " + equalsvalue, severity: 2 })
                this.validators[msgType] = false;
            }
        }
        this.setClass();
    }

    private setOrRemoveErrorDiv(valid: boolean) {
        if (this.errorMessages.length) { this.renderMessageDiv() }
        else { this.removeMessageDiv() };
        ValidationService.GlobalValidation.updateValue(this.element.id, valid);
    }

    private renderMessageDiv() {
        let parent = this.element.parentElement;
        if (parent.getElementsByClassName('error-display').length) {
            this.removeMessageDiv();
        }
        let messageDiv = document.createElement("div");
        messageDiv.className = "error-display";
        messageDiv.style.cssText = 'font-family: Arial, Helvetica, sans-serif;color: #888; position: absolute;top: 36px;'
        messageDiv.innerText = _.sortBy(this.errorMessages, (m) => m.severity)[0].message;
        parent.appendChild(messageDiv);
    }

    private removeMessageDiv() {
        let parent = this.element.parentElement;
        let children = parent.getElementsByClassName('error-display');
        if (children && children.length) {
            parent.removeChild(children[0])
        }
    }
}